import React, { useState, useEffect } from 'react'
import GenericTableforArrayofObjects from '../../GenericComponents/GenericTableforArrayofObjects'
import { useGetManagedimensionQuery } from '../../Redux/Admin_Tasks/DimensionSlice/ManageDimensionSLice'
import { useAppDimensioRowsMutation } from '../../Redux/Admin_Tasks/DimensionSlice/ManageDimensionSLice'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { useTitleContext } from '../../Hooks/useTitleContext'
import { useNavigate } from 'react-router-dom'

const AppDimensionTable: React.FC = () => {
    interface ManageDimensionItem {
        Guid: string
        Name: string
        Description: string
        LastUpdatedOn: Date
    }
    interface FilteredColumns {
        'Action(s)': JSX.Element | string
        'Dimension Name': string
        'Dimension Description': string
        'Last Updated On': string | Date
        Error?: string
    }

    const { setTitle } = useTitleContext()
    setTitle('Dimension Manager')

    const { data = [], isLoading } = useGetManagedimensionQuery()
    // const [AppDimensionRows, resultdata] = useAppDimensioRowsMutation()
    const [setFiltered, setsetFiltered] = useState<FilteredColumns[]>([])
    const navigate = useNavigate()
    const handleManageClick = (guid: string) => {
        navigate(`#appdimensions/rows?Guid=${guid}`)
        // AppDimensionRows({
        //     AppDimensionGuid: guid,
        //     PageNumber: 1,
        //     PageSize: 10,
        //     SearchText: '',
        //     SortDir: 'asc',
        //     SortField: '',
        // })
        //     .unwrap()
        //     .catch((error) => {
        //         console.error('API call failed:', error)
        //     })
    }
    useEffect(() => {
        if (data && Array.isArray(data)) {
            const FilteredColumnsData: FilteredColumns[] =
                data.length > 0
                    ? data.map((item: ManageDimensionItem) => ({
                          'Action(s)': (
                              <a
                                  href="#"
                                  className="float-left btn btn-default btn-sm"
                                  onClick={(e) => {
                                      e.preventDefault()
                                      if (item?.Guid) {
                                          handleManageClick(item.Guid)
                                      }
                                  }}
                              >
                                  Manage Rows
                              </a>
                          ),
                          'Dimension Name': item?.Name || 'Unknown',
                          'Dimension Description': item?.Description || 'No description available',
                          'Last Updated On': item?.LastUpdatedOn || 'N/A',
                      }))
                    : [
                          {
                              'Action(s)': '',
                              'Dimension Name': '',
                              'Dimension Description': '',
                              'Last Updated On': '',
                              Error: 'No dimensions found.',
                          },
                      ]
            setsetFiltered(FilteredColumnsData)
        } else {
            setsetFiltered([
                {
                    'Action(s)': '',
                    'Dimension Name': '',
                    'Dimension Description': '',
                    'Last Updated On': '',
                    Error: 'No dimensions found.',
                },
            ])
        }
    }, [data])
    if (isLoading || !data) {
        return (
            <div>
                <Skeleton loading={isLoading} height="40px" width="100%" />
                <br />
                <Skeleton loading={isLoading} height="30px" width="70%" />
            </div>
        )
    }
    // else{
    return (
        <>
            <div id="dimension-manager">
                <div className="float-right margin-top-small">
                    <a id="link_backto_admin_tasks" href="#AdminTasks">
                        &laquo; Back to Admin Tasks
                    </a>
                </div>
                <div className="header">Manage Dimensions</div>
                <div className="float-right margin-top-small">
                    <span className="sub-info">{data.length}</span>
                    <span className="sub-info"> dimensions</span>
                </div>
                <GenericTableforArrayofObjects items={setFiltered} />
            </div>
        </>
    )
    // }
}

export default AppDimensionTable
